export function getRandomPositions(
  password: string,
  count: number = 3
): { position: number; value: string }[] {
  const positions: { position: number; value: string }[] = [];
  const usedPositions = new Set<number>();

  while (positions.length < count) {
    const randomPosition = Math.floor(Math.random() * password.length);
    if (!usedPositions.has(randomPosition)) {
      usedPositions.add(randomPosition);
      positions.push({
        position: randomPosition,
        value: password[randomPosition],
      });
    }
  }

  return positions.sort((a, b) => a.position - b.position);
}
